const APP_BASE_PATH = '/parts-escalation';
const LEGACY_BASE_PATH = '/carrier-parts-escalation';
const ADMIN_PATH = `${APP_BASE_PATH}/admin`;
const LOGIN_PATH = `${APP_BASE_PATH}/login`;
const CALLBACK_PATH = `${APP_BASE_PATH}/auth/callback`;
const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

function parseAppRoute(pathname, search = '') {
  const path = normalizePath(pathname);
  const query = new URLSearchParams(search);
  const queryCompany = cleanSlug(query.get('company'));

  if (path === ADMIN_PATH) return { kind: 'admin' };
  if (path.startsWith(`${ADMIN_PATH}/`)) return { kind: 'not-found' };

  if (queryCompany) {
    return { kind: 'company', slug: queryCompany };
  }
  if (path === '/' || path === APP_BASE_PATH) {
    return { kind: 'base' };
  }
  if (path === LOGIN_PATH) {
    return { kind: 'login' };
  }
  if (path === CALLBACK_PATH) {
    return { kind: 'callback' };
  }
  if (path.startsWith(`${APP_BASE_PATH}/`)) {
    const segments = path.slice(APP_BASE_PATH.length + 1).split('/');
    const slug = cleanSlug(segments[0]);
    if (segments.length === 1 && slug) {
      return { kind: 'company', slug };
    }
    const equipmentType = cleanSlug(segments[1]);
    if (segments.length === 2 && slug && equipmentType) {
      return { kind: 'form', slug, equipmentType };
    }
  }
  return { kind: 'not-found' };
}

function legacyRedirectPath(pathname, search = '', hash = '') {
  const path = normalizePath(pathname);
  if (path !== LEGACY_BASE_PATH && !path.startsWith(`${LEGACY_BASE_PATH}/`)) {
    return '';
  }
  const suffix = path.slice(LEGACY_BASE_PATH.length);
  return `${APP_BASE_PATH}${suffix}${search || ''}${hash || ''}`;
}

function companyPath(slug) {
  const clean = cleanSlug(slug);
  return clean ? `${APP_BASE_PATH}/${clean}` : APP_BASE_PATH;
}

function equipmentTypePath(companySlug, equipmentTypeSlug) {
  const company = cleanSlug(companySlug);
  const equipmentType = cleanSlug(equipmentTypeSlug);
  return company && equipmentType
    ? `${APP_BASE_PATH}/${company}/${equipmentType}`
    : companyPath(company);
}

function loginPath(returnTo = '') {
  const safePath = safeReturnTo(returnTo, 'https://routing.invalid');
  return safePath
    ? `${LOGIN_PATH}?returnTo=${encodeURIComponent(safePath)}`
    : LOGIN_PATH;
}

function safeReturnTo(value, origin) {
  const url = parseSameOriginUrl(value, origin);
  if (!url || url.search || url.hash) {
    return '';
  }

  const route = parseAppRoute(url.pathname);
  if (route.kind !== 'base' && route.kind !== 'company' && route.kind !== 'form') {
    return '';
  }
  if (route.kind === 'form') {
    return equipmentTypePath(route.slug, route.equipmentType);
  }
  return route.kind === 'company' ? companyPath(route.slug) : APP_BASE_PATH;
}

function safeApplicationUrl(value, origin) {
  const url = parseSameOriginUrl(value, origin);
  if (!url) {
    return '';
  }
  const route = parseAppRoute(url.pathname);
  if (route.kind === 'not-found') {
    return '';
  }
  return `${url.pathname}${url.search}${url.hash}`;
}

function parseSameOriginUrl(value, origin) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) {
    return null;
  }
  try {
    const url = new URL(value, origin);
    return url.origin === origin ? url : null;
  } catch {
    return null;
  }
}

function normalizePath(pathname) {
  const value = String(pathname || '/').replace(/\/{2,}/g, '/');
  return value.length > 1 ? value.replace(/\/+$/, '') : value;
}

function cleanSlug(value) {
  const slug = String(value || '').trim().toLowerCase().replace(/^\/+|\/+$/g, '');
  return SLUG_PATTERN.test(slug) ? slug : '';
}

module.exports = {
  ADMIN_PATH,
  APP_BASE_PATH,
  CALLBACK_PATH,
  LEGACY_BASE_PATH,
  LOGIN_PATH,
  companyPath,
  equipmentTypePath,
  loginPath,
  legacyRedirectPath,
  parseAppRoute,
  safeApplicationUrl,
  safeReturnTo
};
